export const META_DEFAULT_BASE_URL = 'https://www.udemy.com';
export const EVENT_TRACKING_APP_KEY = 'web_main';

export const DEFAULT_REVALIDATE_SECONDS = 60 * 30; // 30 minutes
export const ONE_HOUR = 60 * 60;
export const FOUR_HOURS = ONE_HOUR * 4;
export const ONE_DAY = ONE_HOUR * 24;

// <<Stencil::Block(constants)>>
export const VISITOR_UUID_COOKIE_NAME = '__udmy_2_v57r';
export const VISITOR_UUID_HEADER_NAME = 'x-visitoruuid';

const assetPath = process.env.ASSET_PREFIX;

export const META_DATA = {
    // UD.Config.brand.title
    brandTitle: 'Udemy',
    domain: 'www.udemy.com',
    defaultMetaImage: 'https://s.udemycdn.com/meta/default-meta-image-v2.png',
    appleTouchIcon: `${assetPath}/staticx/udemy/images/v7/apple-touch-icon.png`,
    brandFavIcon: `${assetPath}/staticx/udemy/images/v8/favicon-32x32.png`,
    brandFavIcon16x16: `${assetPath}/staticx/udemy/images/v8/favicon-16x16.png`,
    applicationTitleColor: '#a435f0',
    applicationTitleImage: `${assetPath}/staticx/udemy/images/v7/mstile-144x144.png`,
    applicationConfig: `${assetPath}/staticx/udemy/images/v7/browserconfig.xml`,
    manifest: `${assetPath}/staticx/udemy/images/v7/site-manifest.json`,
    appleItunesApp: 'app-id=562413829, affiliate-data=ct=Safari_SmartBanner&amp;pt=1240482',
    googlePlayApp: 'app-id=com.udemy.android.ufb',
    fbAppId: '313137469260',
};
// <</Stencil::Block>>
